import { COLORS } from '@styles/colors'
import { FONTS } from '@styles/fonts'
import styled from 'styled-components'

export const Auction = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 2px solid ${COLORS.nature.base};
  padding: 0 0 16px;
`

export const AuctionInfo = styled.div`
  color: ${COLORS.secondary};
  font-family: ${FONTS.medium};
`

export const AuctionDate = styled.div`
  font-size: 18px;
  line-height: 26px;
  margin-bottom: 4px;
`

export const AuctionTime = styled.span`
  font-size: 14px;
  line-height: 20px;
`
